module.exports = __webpack_public_path__ + "static/media/plant.47287e6e.svg";